
// WordPressの更新読み込む
var wpJsonpFormat = '<li>' +
	'<a href="{%LINK%}">{%TITLE%}'+
	'<span class="home-news__day">{%POSTDAY%}</span></a></li>';

var CaracolWordpressJsonp = require('../caracol2/wordpress/jquery.wpjsonp.js');
var wp_json = new CaracolWordpressJsonp({ format:wpJsonpFormat, onComplete:onWpJsonpLoad });
wp_json.load('//shingeki.tv/news/output/export_new_jsonp.php');


/***************************************************
* WordPressの更新履歴を読んだら実行
*/
function onWpJsonpLoad( outputArray ){
    // outputArray = outputArray.slice(0, 8);
    $('.js-news-content').append( outputArray.join('') );
	// ニュース部分のスクロール
	$('.js-news-scroll').perfectScrollbar();
}
